module.exports = __webpack_public_path__ + "static/media/monster.d9ae85bd.jpg";